export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/imageupload.worker.007fe14f.worker.js");
}
